import React from "react";
interface props {
  className: string;
}

function Icon1({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //   width="34"
      //   height="34"
      className={className}
      fill="none"
      viewBox="0 0 34 34"
    >
      <path
        fill="#666"
        d="M29.75 6.906H4.25A1.594 1.594 0 002.656 8.5v17a1.594 1.594 0 001.594 1.594h25.5a1.594 1.594 0 001.594-1.594v-17a1.594 1.594 0 00-1.594-1.594zM4.25 7.97h25.5a.531.531 0 01.531.531v3.719H3.72V8.5a.531.531 0 01.531-.531zm25.5 18.062H4.25a.531.531 0 01-.531-.531V13.281H30.28V25.5a.532.532 0 01-.531.531zm-2.656-3.718a.532.532 0 01-.532.53h-4.25a.532.532 0 010-1.062h4.25a.532.532 0 01.532.532zm-8.5 0a.532.532 0 01-.532.53h-2.125a.532.532 0 010-1.062h2.126a.532.532 0 01.53.532z"
      ></path>
    </svg>
  );
}

export default Icon1;
